import React, { useEffect, useRef } from 'react'
import { Modal, Form, Select, Input, Row, Col, DatePicker } from 'antd'
import moment from 'moment'

const { Option } = Select
const { TextArea } = Input

const HOUR_OPTIONS = Array.from({ length: 24 }, (_, i) => i + 1)

const UpdateDescriptionModal = ({
  visible,
  onCancel,
  onSave,
  form,
  eventRow,
  contribConditions,
  selectedDate,
}) => {
  const { getFieldDecorator } = form
  const formRef = useRef(form)

  useEffect(() => {
    formRef.current = form
  }, [form])

  useEffect(() => {
    if (!visible || !eventRow) return
    const allEvents = Object.values(eventRow.eventDataMap || {}).flat()
    const latest =
      allEvents.length > 0
        ? allEvents.reduce((best, e) =>
            (e.eventNum || 0) > (best.eventNum || 0) ? e : best
          )
        : eventRow.eventData

    const hours = Object.keys(eventRow.eventDataMap || {})
      .map(Number)
      .sort((a, b) => a - b)
    const minHour = hours[0] || 1
    const maxHour = hours[hours.length - 1] || 24

    formRef.current.setFieldsValue({
      coc: (latest && latest.coc) || '0',
      description: (latest && latest.description) || undefined,
      startDate: selectedDate ? selectedDate.clone() : moment(),
      startHour: minHour,
      endDate: selectedDate ? selectedDate.clone() : moment(),
      endHour: maxHour,
    })
  }, [visible, eventRow]) // eslint-disable-line react-hooks/exhaustive-deps

  const handleSave = () => {
    form.validateFields((err, values) => {
      if (err) return
      onSave(values, eventRow)
      form.resetFields()
    })
  }

  const label = eventRow ? eventRow.metric : ''

  return (
    <Modal
      visible={visible}
      title={`Update Description — ${label}`}
      onCancel={onCancel}
      onOk={handleSave}
      okText="Save"
      maskClosable={false}
      zIndex={101}
    >
      <Form layout="vertical">
        <Row gutter={8}>
          <Col span={15}>
            <Form.Item label="Start Date">
              {getFieldDecorator('startDate', {
                rules: [{ required: true, message: 'Required' }],
              })(<DatePicker style={{ width: '100%' }} format="MM/DD/YYYY" />)}
            </Form.Item>
          </Col>
          <Col span={9}>
            <Form.Item label="Start Hour">
              {getFieldDecorator('startHour', {
                rules: [{ required: true, message: 'Required' }],
              })(
                <Select>
                  {HOUR_OPTIONS.map(h => (
                    <Option key={h} value={h}>
                      {String(h).padStart(2, '0')}
                    </Option>
                  ))}
                </Select>
              )}
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={8}>
          <Col span={15}>
            <Form.Item label="End Date">
              {getFieldDecorator('endDate', {
                rules: [{ required: true, message: 'Required' }],
              })(<DatePicker style={{ width: '100%' }} format="MM/DD/YYYY" />)}
            </Form.Item>
          </Col>
          <Col span={9}>
            <Form.Item label="End Hour">
              {getFieldDecorator('endHour', {
                rules: [{ required: true, message: 'Required' }],
              })(
                <Select>
                  {HOUR_OPTIONS.map(h => (
                    <Option key={h} value={h}>
                      {String(h).padStart(2, '0')}
                    </Option>
                  ))}
                </Select>
              )}
            </Form.Item>
          </Col>
        </Row>

        <hr style={{ margin: '12px 0', borderColor: '#f0f0f0' }} />

        <Form.Item label="Contributing Operating Condition (COC)">
          {getFieldDecorator('coc', { initialValue: '0' })(
            <Select placeholder="Select COC" allowClear showSearch>
              {(contribConditions || []).map(item => (
                <Option key={item.code} value={item.code}>
                  {item.code} - {item.description}
                </Option>
              ))}
            </Select>
          )}
        </Form.Item>

        <Form.Item label="Description">
          {getFieldDecorator('description')(<TextArea rows={3} />)}
        </Form.Item>
      </Form>
    </Modal>
  )
}

export default Form.create()(UpdateDescriptionModal)
